import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    logoImage = "logoImage",
    logoUrl = "logoUrl",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.logoImage]: string;
        [fields.logoUrl]: string;
    };
    extendedStyles?: LogoStyles;
}

type Props = OwnProps;

export interface LogoStyles {
    wrapper?: InjectableCss;
    image?: LazyImageProps;
}

export const logoStyles: LogoStyles = {
    wrapper: {
        css: css`
            max-width: 300px;
            max-height: 110px;
            margin: auto;
        `,
    },
    image: {
        css: css`
            width: 100%;
            display: block;
            margin: 0;
            > img {
                vertical-align: middle;
            }
        `,
    },
};

const MobileLogo: React.FunctionComponent<Props> = ({ fields, extendedStyles }: Props) => {
    const [styles] = React.useState(() => mergeToNew(logoStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper}>
            <Link href={fields.logoUrl}>
                <LazyImage src={fields.logoImage} altText={translate("home")} {...styles.image} />
            </Link>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: MobileLogo,
    definition: {
        group: "Basic",
        icon: "Logo",
        fieldDefinitions: [
            {
                name: fields.logoImage,
                displayName: "Logo Image",
                editorTemplate: "ImagePickerField",
                defaultValue: "",
                fieldType: "Translatable",
            },
            {
                name: fields.logoUrl,
                displayName: "Logo url",
                editorTemplate: "TextField",
                defaultValue: "/categories",
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
